import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const ProfessionalSituation = ({ roles }) => {

    return (
        <M_Table entityName={'DriverProfessionalSituation'} filtersOnTable rolePermissions={roles} />
    )
}